import { ComplextRoute } from 'router/components/Routes/Routes';
import CreateDealRoom from './pages/CreateDealRoom';

export default [
  {
    index: true,
    element: CreateDealRoom,
  },
] as Array<ComplextRoute>;
